import { Component, Input } from '@angular/core';
import { ApiService } from '../../_services';

@Component({
	selector: 'created-by',
	template: require('./created-by.component.html')
})
export class CreatedByComponent {

	entityType : string = null;
	entityId: any = null; 

	audit$: Promise<any>;

	constructor(private api: ApiService) { }


	@Input("entityType")
	set type(value: string) {
		this.entityType = value;
		this.updateAudit();
	}

	@Input("entityId")
	set id(value: any) {
		this.entityId = value;
		this.updateAudit();

	}

	updateAudit = () => {
		if (!!this.entityType && !!this.entityId)
			this.audit$ = this.api.audits.getAudits(this.entityType, this.entityId);
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/audit/created-by.component.ts